import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { HierarchyService } from '../services/hierarchy.service';
import { SearchResult, SearchResultRow } from './../../models/common/search-result';

@Component({
  selector: '',
  template: '',
})
export class MyTeamDetailsSearchHandler extends BaseSearchComponent<HierarchyService> implements OnInit {
  public searchName: string;
  public agentName: string;
  isAdvanceSearchDisplayed: boolean;
  //

  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    // this.addLink = '/search-my-team-details';
    //this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchName = 'SearchMyTeamDetails';

    //this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'MyTeamDetails',
        link: '/search-my-team-details',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Profile',
        link: '/profile/:id',
      },
      {
        id: 'ProductionDetails',
        link: '/search-production-details/:id',
      },
      {
        id: 'BalanceDetails',
        link: '/search-balance-details/:id',
      },
      {
        id: 'teamContest',
        link: '/search-team-contest/:id',
      },
      {
        id: 'teamIncentive',
        link: '/search-team-incentive/:id',
      },
      {
        id: 'uplineHierarchy',
        link: '/upline-hierarchy-details/:id',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('MyTeamDetails');

    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
  }

  Profile_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    const navigationExtras = optionDetails.ref_id;
    this.router.navigate([link]);
  }

  ProductionDetails_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    const navigationExtras = optionDetails.ref_id;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  CompensationEvaluation_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link], optionDetails.ref_id);
  }

  teamContest_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    // this.router.navigate([link], optionDetails.ref_id);
    this.router.navigate([link, this.agentName]);
  }

  teamIncentive_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    // this.router.navigate([link], optionDetails.ref_id);
    this.router.navigate([link, this.agentName]);
  }

  BalanceDetails_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    const navigationExtras = optionDetails.ref_id;
    this.router.navigate([link]);
  }

  SubordinateDetails_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    const navigationExtras = optionDetails.ref_id;
    this.router.navigate([link]);
  }

  uplineHierarchy_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link], optionDetails.ref_id);
  }

  /**
   * This is triggered when more option list icon is clicked. This modifies the more option list based on the condition.
   * @param searchRecord current selected row
   */
  onMoreButtonClicked(searchRecord: SearchResultRow) {
    this.agentName = this.getRecordValue(searchRecord, 'AgentMasterDO.agentName');
  }
}
